export default "__VITE_ASSET__BlAuTKbf__"